import obelisk from '../clients/obelisk';
import { getCall } from '../hooks/Network';
import { cacheGet } from '../util/cache';
import PropTypes from 'prop-types';

export const associateGetService = async (associateId, jwtToken) => {
  try {
    const bearerToken = cacheGet('apiToken', true, { jwtToken: jwtToken || '' });
    const data = {
      url: 'getAssociate',
      urlParams: { associateId },
      headers: { Authorization: 'Bearer ' + bearerToken.jwtToken },
    };
    const http = await getCall(data);
    return http.data;
  } catch (error) {
    console.error('Error fetching associate:', error);
    return null;
  }
};

export const associateGetAutoShipService = async (associateId) => {
  try {
    const response = await obelisk().get('AutoShip/GetAutoShipByAssociateId', {
      associateId,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching associate autoship:', error);
  }
};

export const associateGetRegion = async (
  countryCode,
  stateCode = 'ALL',
  defaultRegion = 2
) => {
  try {
    const response = await obelisk().get('Product/GetRegion', {
      countryCode,
      stateCode,
    });
    return response.data?.regionId || defaultRegion;
  } catch (error) {
    console.error('Error fetching associate region:', error);
  }
};

export const associateGetPillarsUserService = async (username) => {
  try {
    const response = await obelisk()
      .get('Associate/GetTreeToken', {
        username,
      })
      .then((res) => ({
        data: res?.data?.tokenDetails,
      }));
    return response;
  } catch (error) {
    console.error('Error fetching pillars user data:', error);
  }
};

associateGetPillarsUserService.propTypes = {
  email: PropTypes.string.isRequired,
};
